export default __webpack_public_path__ + "static/media/image4.fe9aed4a.jpg";